// React libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
// Components
import LoadingOverlay from 'react-loading-overlay';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button } from 'reactstrap';
// Custom components
import BidQuoteSlider from '../../components/Sliders/BidQuoteSlider';
// Services
import { getWeight } from '../../commons/helpers';
import {
    getBookingForBidding,
    getBookingForConfirm,
    approveBooking,
} from '../../state/services/bookingService';

class BidPricePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessage: null,
            isLoading: false,
            isShowBidQuoteSlider: false,
            currentPackedStatus: '',
            selectedLineIndex: -1,
            isChecked: false,            
        };
        this.toggleBidQuoteSlider = this.toggleBidQuoteSlider.bind(this);
    }

    static propTypes = {
        getBookingForBidding: PropTypes.func.isRequired,
        getBookingForConfirm: PropTypes.func.isRequired,
        approveBooking: PropTypes.func.isRequired,
        booking: PropTypes.object,
        match: PropTypes.object,
        errorMessage: PropTypes.string,
        approveMessage: PropTypes.string,
        message: PropTypes.string,
        loadSuccess: PropTypes.bool,
        location: PropTypes.object.isRequired,
    };

    notify = (text) => toast(text);

    toggleBidQuoteSlider() {
        const pageType = this.props.location.pathname.split('/')[1];
        if (pageType === 'bid-decline') {
            const { booking } = this.props;
            const quote = booking && booking['pricings'] ? booking['pricings'][0] : null;   
            if (quote) {
                this.notify('Failed. You already submitted the quote.');
                return;
            }
        }
        this.setState(prevState => ({isShowBidQuoteSlider: !prevState.isShowBidQuoteSlider}));
    }

    componentDidMount() {
        const identifier = this.props.match.params.id;
        const pageType = this.props.location.pathname.split('/')[1];

        if (identifier && identifier.length > 32 && (pageType === 'bid' || pageType === 'bid-decline')) {
            this.props.getBookingForBidding(identifier);

            this.setState({isLoading: true});
        } else if (identifier && identifier.length > 32 && pageType === 'confirm') {
            this.props.getBookingForConfirm(identifier);

            this.setState({isLoading: true});
        } else if (
            identifier &&
            identifier.length > 32 &&
            (pageType === 'approve' || pageType === 'disapprove-hold' || pageType === 'disapprove-disposal')) {
            this.props.approveBooking(identifier, pageType);
            this.props.getBookingForBidding(identifier);

            this.setState({isLoading: true});
        } else {
            this.setState({errorMessage: 'Wrong id.'});
        }       
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const {errorMessage} = newProps;

        if (errorMessage) {
            this.setState({errorMessage});
        } 

        if (this.state.isLoading && !this.props.loadSuccess && newProps.loadSuccess) {
            this.setState({isLoading: false});
        }

        if (this.state.isLoading && errorMessage) {
            this.setState({ isLoading: false });
        }
    }
    
    onBidQuote() {
        this.toggleBidQuoteSlider();
        this.props.getBookingForBidding(this.props.match.params.id);
    }

    onClickShowLine(index) {
        this.setState({selectedLineIndex: index});
    }

    render() {
        const {currentPackedStatus, selectedLineIndex, isChecked} = this.state;
        const {booking, errorMessage, approveMessage} = this.props;
        const pageType = this.props.location.pathname.split('/')[1];

        let selected_booking, booking_lines, lineDetailList, elapsedTime;
        let canBeChanged = true;
        let totalCubicMeter = 0;
        let totalLinesCnt = 0;
        let totalLinesKg = 0;
        let hasUnknownItems = false;
        let errorList = [];
        let _currentPackedStatus = currentPackedStatus || 'original';
        let pickupTimeRange = '';
        let deliverTimeRange = '';
        const quote = booking && booking['pricings'] ? booking['pricings'][0] : null;       

        if (booking) {
            const now = new Date();
            const target = new Date(booking['z_CreatedTimestamp']);
            elapsedTime = Math.floor((now - target)/1000); // Difference in milliseconds

            if (booking['b_dateBookedDate']) {
                canBeChanged = false;
            } else {
                canBeChanged = elapsedTime <= 60 * 60; // Disable to update quote after an hour
            }            
        }        

        canBeChanged = canBeChanged && (isChecked || quote);
        canBeChanged = canBeChanged || pageType !== 'bid';
            
        let message = errorMessage;
        let isConfirmed = false;
        if (booking && errorMessage) {
            if (errorMessage.indexOf('Confirmed') !== -1) {
                isConfirmed = true;
            }
        } else if (quote && quote.client_mu_1_minimum_values <= 0) {
            isConfirmed = true;
            message = 'Your Quote Bid has been Declined.';
        }

        if (booking) {
            selected_booking = booking;

            if (selected_booking && selected_booking['b_error_Capture']) {
                // Errors are joined with delimiter('***')
                errorList = selected_booking['b_error_Capture']
                    .split('***')
                    .map((error, index) => {
                        if (error.indexOf('Error') !== -1)
                            return (<li key={index} className={'c-red ignored-items'}>{index + 1}) {error}</li>);
                        else
                            return (<li key={index} className={'c-orange ignored-items'}>{index + 1}) {error}</li>);
                    });
            }

            booking_lines = selected_booking['booking_lines']
                // .filter(bookingLine => bookingLine['packed_status'] === _currentPackedStatus)
                .map((bookingLine, index) => {
                    totalLinesKg += Number.parseFloat(getWeight(bookingLine['e_qty'], bookingLine['e_weightUOM'], bookingLine['e_weightPerEach']));
                    totalLinesCnt += bookingLine['e_qty'];
                    totalCubicMeter += bookingLine['e_1_Total_dimCubicMeter'];

                    let isUnknownLine = bookingLine['e_item'].indexOf('(ZERO Dims') > -1;

                    if (!hasUnknownItems && isUnknownLine)
                        hasUnknownItems = true;

                    return (
                        <tr
                            key={index}
                            className={isUnknownLine ? 'unknown' : selectedLineIndex === index ? 'selected' : null}
                            onClick={() => this.onClickShowLine(index)}
                        >
                            <td>{bookingLine['e_type_of_packaging']}</td>
                            <td>{bookingLine['e_item_type']}</td>
                            <td>{bookingLine['e_item']}</td>
                            <td>{bookingLine['e_qty']}</td>
                            <td>{bookingLine['e_dimUOM']}</td>
                            <td>{bookingLine['e_dimLength']}</td>
                            <td>{bookingLine['e_dimWidth']}</td>
                            <td>{bookingLine['e_dimHeight']}</td>
                            <td>{bookingLine['e_1_Total_dimCubicMeter'].toFixed(3)} (m3)</td>
                            <td>{(bookingLine['e_qty'] * bookingLine['e_weightPerEach']).toFixed(3)} ({bookingLine['e_weightUOM']})</td>                     
                        </tr>
                    );
                });

            lineDetailList = selected_booking['booking_lines_data'].map((lineDetail, index) => {
                const isDetailOfSelectedLine = selectedLineIndex > -1 && selected_booking['booking_lines'][selectedLineIndex].pk_booking_lines_id === lineDetail.fk_booking_lines_id;
                
                if (isDetailOfSelectedLine) {
    
                    return (
                        <tr key={index}>
                            <td>{lineDetail.modelNumber}</td>
                            <td>{lineDetail.itemDescription}</td>
                            <td>{lineDetail.quantity}</td>
                            <td>{lineDetail.itemFaultDescription}</td>
                            <td>${lineDetail.insuranceValueEach ? lineDetail.insuranceValueEach : 0}</td>
                            <td>{lineDetail.gap_ra}</td>
                            <td>{lineDetail.clientRefNumber}</td>
                        </tr>
                    );
                }
            });

            const pickupFromDate = selected_booking['puPickUpAvailFrom_Date'] ? moment(selected_booking['puPickUpAvailFrom_Date']).format('DD/MM/YYYY') : '';
            const pickupFromHour = selected_booking['pu_PickUp_Avail_Time_Hours'] ? String(selected_booking['pu_PickUp_Avail_Time_Hours']).padStart(2, '0') + ':' : '00:';
            const pickupFromMinute = selected_booking['pu_PickUp_Avail_Time_Minutes'] ? String(selected_booking['pu_PickUp_Avail_Time_Minutes']).padStart(2, '0') : '00';
            const pickupByDate = selected_booking['pu_PickUp_By_Date'] ? moment(selected_booking['pu_PickUp_By_Date']).format('DD/MM/YYYY') : '';
            const pickupByHour = selected_booking['pu_PickUp_By_Time_Hours'] ? String(selected_booking['pu_PickUp_By_Time_Hours']).padStart(2, '0') + ':' : '00:';
            const pickupByMinute = selected_booking['pu_PickUp_By_Time_Minutes'] ? String(selected_booking['pu_PickUp_By_Time_Minutes']).padStart(2, '0')  : '00';

            pickupTimeRange = `${pickupFromDate} ${pickupFromHour}${pickupFromMinute} - ${pickupByDate} ${pickupByHour}${pickupByMinute}`;

            const deliverFromDate = selected_booking['de_Deliver_From_Date'] ? moment(selected_booking['de_Deliver_From_Date']).format('DD/MM/YYYY') : '';
            const deliverFromHour = selected_booking['de_Deliver_From_Hours'] ? String(selected_booking['de_Deliver_From_Hours']).padStart(2, '0') + ':' : '00:';
            const deliverFromMinute = selected_booking['de_Deliver_From_Minutes'] ? String(selected_booking['de_Deliver_From_Minutes']).padStart(2, '0') : '00';
            const deliverByDate = selected_booking['de_Deliver_By_Date'] ? moment(selected_booking['de_Deliver_By_Date']).format('DD/MM/YYYY') : '';
            const deliverByHour = selected_booking['de_Deliver_By_Hours'] ? String(selected_booking['de_Deliver_By_Hours']).padStart(2, '0') + ':' : '00:';
            const deliverByMinute = selected_booking['de_Deliver_By_Minutes'] ? String(selected_booking['de_Deliver_By_Minutes']).padStart(2, '0') : '00';

            deliverTimeRange = `${deliverFromDate} ${deliverFromHour}${deliverFromMinute} - ${deliverByDate} ${deliverByHour}${deliverByMinute}`;
            
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                styles={{height: 'calc(100% - 114px)'}}
                className="loading-pane"
                spinner
                text='Loading...'
            >
                <section className="bid-price">
                    {(this.state.errorMessage || !selected_booking) && !isConfirmed ?
                        <h1>{this.state.errorMessage}</h1>
                        :
                        <div>
                            {isConfirmed && <div className='confirm-message'><h1>{message}</h1></div>}
                            {quote && pageType == 'bid' ? (
                                <div className='info-box'>
                                    <strong>Thank you for your quote.</strong>
                                    <br/>
                                    <strong>Quote: ${parseFloat(quote.client_mu_1_minimum_values).toFixed(2)}</strong>
                                    <br/>
                                    <strong>Anything we should know : {quote.notes}</strong>
                                </div>
                            ) : (
                                <div>
                                    <h5>1. <b>Product Condition:</b> Please advise Ariston immediately if your driver notices any product damage during collection or delivery.</h5>
                                    <h5>2. <b>Loading Records:</b> Take a loading photograph for your records.</h5>
                                    <h5>3. <b>Product Protection:</b> Ensure that the product remains dry and is properly tarped during transport.</h5>
                                    <h5>4. <b>Delivery Docket:</b> Request two copies of the Delivery Docket from the collection warehouse:</h5>
                                    <h5 style={{marginLeft: '20px'}}><li> One copy should be signed by the recipient and emailed back to Ariston. </li> </h5>
                                    <h5 style={{marginLeft: '20px'}}><li> The other copy should be provided to the recipient.  </li></h5>
                                    <h5>5. <b>LOSCAM Pallets:</b> If LOSCAM pallets are used, note that they have been transferred directly from the sending customer&apos;s account to the receiving customer&apos;s account.</h5>
                                    <h5>6. <b>Forklift Availability:</b> A forklift will be provided by both the consignee and the receiver for loading and unloading.</h5>
                                    <h5>7. <b>Issue Reporting:</b> Advise Ariston as soon as possible of any issues encountered with collection, transport, or delivery.</h5>
                                    <h5>8. <b>Further Assistance:</b> For further information or assistance, contact Ariston Customer Service on 1800 359 356.</h5>
                                    <h5>9. <b>Delivery instructions:</b></h5>
                                    <h5 style={{marginLeft: '20px'}}>{selected_booking['de_to_PickUp_Instructions_Address']}</h5>
                                    {pageType == 'bid' ? (
                                        <h5><input type='checkbox' onClick={() => this.setState({ isChecked: !isChecked })} /> Please read the above and confirm understanding. * A quote cannot be submitted unless this is ticked before clicking the submit button.</h5>
                                    ) : null}
                                </div>
                            )}
                            {pageType === 'bid' || pageType === 'bid-decline' ? (
                                <div className={isConfirmed ? 'decision none' : quote && pageType === 'bid' ? 'decision update' : 'decision'}>
                                    <Button
                                        disabled={canBeChanged ? null : true}
                                        color="primary"
                                        onClick={() => this.toggleBidQuoteSlider()}
                                    >
                                        {pageType === 'bid-decline' ? 'Decline' : elapsedTime > 60 * 60? 'Quote Period Closed' : quote ? 'Update Quote' : 'Enter Quote'  }
                                    </Button>
                                </div>
                            ) : pageType === 'approve' || pageType === 'disapprove-hold' || pageType === 'disapprove-disposal' ? (
                                <div className='confirm-message'>
                                    <h1>{approveMessage}</h1><br />
                                    <h2>No further action is require if any other help is needed please contact the DME service team</h2>
                                </div>
                            ) : <br />}
                            <h3><i className="fa fa-circle"></i> Main Info:</h3>
                            <div className="main-info">
                                <div className="">
                                    <strong>Client Name: </strong><span>{selected_booking['b_client_name']}</span><br />
                                    <strong>Reference No: </strong><span>{selected_booking['b_client_order_num']}</span><br />
                                </div>
                                <div className="pu-info disp-inline-block">
                                    <label>Pickup From</label><br />
                                    <div className="title disp-inline-block">
                                        <strong>Pickup Time Range: </strong><br />
                                        <strong>Entity Name: </strong><br />
                                        <strong>Street 1: </strong><br />
                                        <strong>Street 2: </strong><br />
                                        <strong>Suburb: </strong><br />
                                        <strong>State: </strong><br />
                                        <strong>PostalCode: </strong><br />
                                        <strong>Country: </strong><br />
                                        <strong>Contact Name: </strong><br />
                                        <strong>Email: </strong><br />
                                        <strong>Phone: </strong><br />
                                    </div>
                                    <div className="data disp-inline-block">
                                        <span>
                                            {pickupTimeRange}
                                        </span><br />
                                        <span>{selected_booking['puCompany']}</span><br />
                                        <span>{selected_booking['pu_Address_Street_1']}</span><br />
                                        {selected_booking && selected_booking['pu_Address_street_2'] && (<span>{selected_booking['pu_Address_street_2']}</span>)}<br />
                                        <span>{selected_booking['pu_Address_Suburb']}</span><br />
                                        <span>{selected_booking['pu_Address_State']}</span><br />
                                        <span>{selected_booking['pu_Address_PostalCode']}</span><br />
                                        <span>{selected_booking['pu_Address_Country']}</span><br />
                                        <span>{selected_booking['pu_Contact_F_L_Name']}</span><br />
                                        <span>{selected_booking['pu_Email']}</span><br />
                                        <span>{selected_booking['pu_Phone_Main']}</span><br />
                                    </div>
                                </div>
                                <div className="de-info disp-inline-block">
                                    <label>Deliver To</label><br />
                                    <div className="title disp-inline-block">
                                        <strong>Deliver Time Range: </strong><br />
                                        <strong>Entity Name: </strong><br />
                                        <strong>Street 1: </strong><br />
                                        <strong>Street 2: </strong><br />
                                        <strong>Suburb: </strong><br />
                                        <strong>State: </strong><br />
                                        <strong>PostalCode: </strong><br />
                                        <strong>Country: </strong><br />
                                        <strong>Contact Name: </strong><br />
                                        <strong>Email: </strong><br />
                                        <strong>Phone: </strong><br />
                                    </div>
                                    <div className="data disp-inline-block">
                                        <span>
                                            {deliverTimeRange}
                                        </span><br />
                                        <span>{selected_booking['deToCompanyName']}</span><br />
                                        <span>{selected_booking['de_To_Address_Street_1']}</span><br />
                                        {selected_booking && selected_booking['de_To_Address_Street_2'] && (<span>{selected_booking['de_To_Address_Street_2']}</span>)}<br />
                                        <span>{selected_booking['de_To_Address_Suburb']}</span><br />
                                        <span>{selected_booking['de_To_Address_State']}</span><br />
                                        <span>{selected_booking['de_To_Address_PostalCode']}</span><br />
                                        <span>{selected_booking['de_To_Address_Country']}</span><br />
                                        <span>{selected_booking['de_to_Contact_F_LName']}</span><br />
                                        <span>{selected_booking['de_Email']}</span><br />
                                        <span>{selected_booking['de_to_Phone_Main']}</span><br />
                                    </div>
                                </div>
                                <ul>{errorList}</ul>
                            </div>
                            <LoadingOverlay
                                active={this.state.isLoading}
                                spinner
                                text='Loading...'
                            >
                                <h3><i className="fa fa-circle"></i> Lines:</h3>
                                {totalLinesCnt ?
                                    <table className="table table-hover table-bordered sortable fixed_headers">
                                        <thead>
                                            <tr>
                                                <th>Total Quantity</th>
                                                <th>Total Weight (Kg)</th>
                                                <th>Total Cubic Meter (M3)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{totalLinesCnt}</td>
                                                <td>{totalLinesKg}</td>
                                                <td>{totalCubicMeter.toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    :
                                    null
                                }
                                <div className="table-wrapper">
                                    <table className="table table-hover table-bordered sortable fixed_headers">
                                        <thead>
                                            <tr>
                                                <th className="valign-top">Type Of Packaging</th>
                                                <th className="valign-top">Item No</th>
                                                <th className="valign-top">Item Descripton</th>
                                                <th className="valign-top">Qty</th>
                                                <th className="valign-top">Dim UOM</th>
                                                <th className="valign-top">Length</th>
                                                <th className="valign-top">Width</th>
                                                <th className="valign-top">Height</th>
                                                <th className="valign-top">{_currentPackedStatus === 'auto' ? 'Pallet CBM' : 'CBM'}</th>
                                                <th className="valign-top">Total Weight</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {booking_lines}
                                        </tbody>
                                    </table>
                                </div>
                                {selectedLineIndex > -1 &&
                                    <div className="line-detail-section">
                                        <h3><i className="fa fa-circle"></i> Line Details:</h3>
                                        <div className="table-wrapper">
                                            <table className="table table-hover table-bordered sortable fixed_headers">
                                                <thead>
                                                    <tr>
                                                        <th className="valign-top">Model</th>
                                                        <th className="valign-top">Item Descripton</th>
                                                        <th className="valign-top">Qty</th>
                                                        <th className="valign-top">Fault Description</th>
                                                        <th className="valign-top">Insurance Value</th>
                                                        <th className="valign-top">Gap / RA</th>
                                                        <th className="valign-top">Client Reference #</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {lineDetailList}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                }
                                {pageType === 'bid' && (
                                    <div className={isConfirmed ? 'decision none' : quote ? 'decision update' : 'decision'}>
                                        <Button
                                            disabled={canBeChanged ? null : true}
                                            color="primary"
                                            onClick={() => this.toggleBidQuoteSlider()}
                                        >
                                            {elapsedTime > 60 * 60 ? 'Quote Period Closed' : quote ? 'Update Quote' : 'Enter Quote'  }
                                        </Button>
                                    </div>
                                )}
                            </LoadingOverlay>
                        </div>
                    }           

                    <BidQuoteSlider
                        isOpen={this.state.isShowBidQuoteSlider}
                        token={this.props.match.params.id}
                        toggleSlider={this.toggleBidQuoteSlider}
                        quote={quote}
                        onSubmit={() => this.onBidQuote()}
                        location={this.props.location}
                    />
                </section>
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        errorMessage: state.booking.errorMessage,
        approveMessage: state.booking.approveMessage,
        booking: state.booking.booking,
        loadSuccess: state.booking.loadSuccess,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBookingForBidding: (identifier) => dispatch(getBookingForBidding(identifier)),
        getBookingForConfirm: (identifier) => dispatch(getBookingForConfirm(identifier)),
        approveBooking: (identifier, decision) => dispatch(approveBooking(identifier, decision)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BidPricePage);



// WEBPACK FOOTER //
// ./src/pages/customer/BidPricePage.js